<template>
  <nav class="navbar navbar-expand-lg">
    <div class="container-fluid">

      <!-- Logo (shared, always visible) -->
      <router-link class="navbar-brand" to="/">
        <img src="@/assets/images/favicon.png" alt="logo" />
      </router-link>

      <!-- ══════════════════════════════════════════════
           MOBILE APP HEADER  (≤768px only)
           Replaces hamburger with a native-app header
      ══════════════════════════════════════════════ -->
      <div class="mnh">
        <span class="mnh-title">طارق المحلاوي</span>
        <div class="mnh-end">

          <!-- Guest: login shortcut -->
          <router-link v-if="!auth" to="/login" class="mnh-login-btn" aria-label="تسجيل الدخول">
            <i class="pi pi-sign-in"></i>
            <span>دخول</span>
          </router-link>

          <!-- Auth: avatar button → opens bottom sheet -->
          <button
            v-else
            class="mnh-avatar-btn"
            type="button"
            @click="sheetOpen = true"
            :aria-label="user?.name"
          >
            <span class="mnh-avatar-letter">{{ user?.name?.charAt(0) || 'م' }}</span>
          </button>
        </div>
      </div>
      <!-- ══ END MOBILE APP HEADER ══ -->

      <!-- Desktop mobile toggle (768px – 991.98px) -->
      <button
        class="nav-toggler"
        :class="{ open: menuOpen }"
        @click="menuOpen = !menuOpen"
        aria-label="القائمة"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      <!-- Desktop nav items -->
      <ul class="navbar-nav" :class="{ 'mobile-open': menuOpen }">

        <!-- Guest links -->
        <li class="nav-item" v-if="!auth">
          <router-link class="nav-link" to="/search" @click="menuOpen = false">
            🔍 أبحث عن حجزي
          </router-link>
        </li>
        <li class="nav-item" v-if="!auth">
          <router-link class="navbar-login-link" to="/login" @click="menuOpen = false">
            تسجيل الدخول
          </router-link>
        </li>

        <!-- Authenticated user dropdown -->
        <div class="dropdown nav-item" v-if="auth">
          <button
            class="btn dropdown-toggle"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i class="pi pi-user" style="font-size:.85rem"></i>
            {{ user?.name }}
            <span style="opacity:.75;font-size:.8rem">({{ user?.academic_year?.name || '' }})</span>
          </button>
          <ul class="dropdown-menu">
            <li>
              <router-link class="dropdown-item" to="/my_exams" @click="menuOpen = false">
                <i class="pi pi-chart-bar"></i> امتحاناتي
              </router-link>
            </li>
            <li>
              <router-link class="dropdown-item" to="/contents" @click="menuOpen = false">
                <i class="pi pi-book"></i> محتوى الحصص
              </router-link>
            </li>
            <li>
              <router-link class="dropdown-item" to="/exams?type=online" @click="menuOpen = false">
                <i class="pi pi-file-edit"></i> الامتحانات
              </router-link>
            </li>
            <li>
              <router-link class="dropdown-item" to="/exams?type=homework" @click="menuOpen = false">
                <i class="pi pi-home"></i> واجب منزلي
              </router-link>
            </li>
            <li><hr class="dropdown-divider" style="margin:.25rem .5rem;opacity:.08" /></li>
            <li>
              <router-link class="dropdown-item" to="/update_password" @click="menuOpen = false">
                <i class="pi pi-lock"></i> تعديل كلمة المرور
              </router-link>
            </li>
            <li>
              <router-link class="dropdown-item" to="/update_data" @click="menuOpen = false">
                <i class="pi pi-user-edit"></i> تعديل البيانات
              </router-link>
            </li>
            <li>
              <router-link class="dropdown-item" to="/whatsapp_link" @click="menuOpen = false">
                <i class="pi pi-whatsapp"></i> مجموعة الواتساب
              </router-link>
            </li>
            <li><hr class="dropdown-divider" style="margin:.25rem .5rem;opacity:.08" /></li>
            <li>
              <p class="dropdown-item mb-0" style="color:#EF4444" @click="logout">
                <i class="pi pi-sign-out"></i> تسجيل الخروج
              </p>
            </li>
          </ul>
        </div>

        <!-- Credit inside mobile menu -->
        <li class="nav-item nav-credit-mobile">
          <div class="nav-credit-mobile-inner">
            <span>Powered by <strong>Ahmed Hawam</strong> ⚡</span>
            <div class="nav-credit-socials">
              <a href="https://github.com/AhmedHawam9" target="_blank" rel="noopener" class="ncs-link" aria-label="GitHub">
                <svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z"/></svg>
              </a>
              <a href="https://linkedin.com/in/ahmed-hawam" target="_blank" rel="noopener" class="ncs-link" aria-label="LinkedIn">
                <svg viewBox="0 0 24 24" fill="currentColor"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
              </a>
              <a href="https://instagram.com/ahmed.hawam" target="_blank" rel="noopener" class="ncs-link" aria-label="Instagram">
                <svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg>
              </a>
            </div>
          </div>
        </li>

      </ul>
    </div>
  </nav>

  <!-- ══════════════════════════════════════════
       MOBILE PROFILE BOTTOM SHEET
       Teleported to <body> so it layers over everything
  ══════════════════════════════════════════ -->
  <Teleport to="body">
    <!-- Backdrop -->
    <Transition name="mbs-backdrop">
      <div
        v-if="sheetOpen"
        class="mbs-backdrop"
        @click="closeSheet"
      ></div>
    </Transition>

    <!-- Sheet -->
    <Transition name="mbs-sheet">
      <div
        v-if="sheetOpen"
        class="mbs-sheet"
        ref="sheetEl"
        @touchstart.passive="onTouchStart"
        @touchmove.passive="onTouchMove"
        @touchend.passive="onTouchEnd"
        :style="dragStyle"
        dir="rtl"
      >
        <!-- Drag handle + close button row -->
        <div class="mbs-top-bar">
          <div class="mbs-handle-bar"></div>
          <button class="mbs-close-btn" @click="closeSheet" aria-label="إغلاق">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round">
              <path d="M18 6L6 18M6 6l12 12"/>
            </svg>
          </button>
        </div>

        <!-- Profile header -->
        <div class="mbs-profile">
          <div class="mbs-avatar">
            <span class="mbs-avatar-letter">{{ user?.name?.charAt(0) || 'م' }}</span>
          </div>
          <div class="mbs-profile-info">
            <div class="mbs-profile-name">{{ user?.name }}</div>
            <div class="mbs-profile-grade">{{ user?.academic_year?.name || '' }}</div>
          </div>
        </div>

        <!-- Menu items -->
        <nav class="mbs-nav">

          <div class="mbs-section-label">التعلم</div>

          <button class="mbs-item" @click="navTo('/my_exams')">
            <span class="mbs-item-icon mbs-ic-blue"><i class="pi pi-chart-bar"></i></span>
            <span class="mbs-item-label">امتحاناتي</span>
            <i class="pi pi-angle-left mbs-item-arrow"></i>
          </button>
          <button class="mbs-item" @click="navTo('/contents')">
            <span class="mbs-item-icon mbs-ic-purple"><i class="pi pi-book"></i></span>
            <span class="mbs-item-label">محتوى الحصص</span>
            <i class="pi pi-angle-left mbs-item-arrow"></i>
          </button>
          <button class="mbs-item" @click="navTo('/exams?type=online')">
            <span class="mbs-item-icon mbs-ic-teal"><i class="pi pi-file-edit"></i></span>
            <span class="mbs-item-label">الامتحانات</span>
            <i class="pi pi-angle-left mbs-item-arrow"></i>
          </button>
          <button class="mbs-item" @click="navTo('/exams?type=homework')">
            <span class="mbs-item-icon mbs-ic-orange"><i class="pi pi-home"></i></span>
            <span class="mbs-item-label">الواجب المنزلي</span>
            <i class="pi pi-angle-left mbs-item-arrow"></i>
          </button>

          <div class="mbs-divider"></div>
          <div class="mbs-section-label">الحساب</div>

          <button class="mbs-item" @click="navTo('/update_data')">
            <span class="mbs-item-icon mbs-ic-slate"><i class="pi pi-user-edit"></i></span>
            <span class="mbs-item-label">تعديل البيانات</span>
            <i class="pi pi-angle-left mbs-item-arrow"></i>
          </button>
          <button class="mbs-item" @click="navTo('/update_password')">
            <span class="mbs-item-icon mbs-ic-slate"><i class="pi pi-lock"></i></span>
            <span class="mbs-item-label">تعديل كلمة المرور</span>
            <i class="pi pi-angle-left mbs-item-arrow"></i>
          </button>
          <button class="mbs-item" @click="navTo('/whatsapp_link')">
            <span class="mbs-item-icon mbs-ic-green"><i class="pi pi-whatsapp"></i></span>
            <span class="mbs-item-label">مجموعة الواتساب</span>
            <i class="pi pi-angle-left mbs-item-arrow"></i>
          </button>

          <div class="mbs-divider"></div>

          <button class="mbs-item mbs-item-logout" @click="doLogout">
            <span class="mbs-item-icon mbs-ic-red"><i class="pi pi-sign-out"></i></span>
            <span class="mbs-item-label">تسجيل الخروج</span>
          </button>

        </nav>

        <!-- Safe-area spacer -->
        <div class="mbs-safe-area"></div>
      </div>
    </Transition>
  </Teleport>
</template>

<script>
import Swal from "sweetalert2";

export default {
  name: "navbar",
  data() {
    return {
      auth: false,
      menuOpen: false,
      sheetOpen: false,
      user: JSON.parse(localStorage.getItem("user")),
      // swipe state
      _touchStartY: 0,
      _dragY: 0,
      _dragging: false,
    };
  },
  computed: {
    dragStyle() {
      if (!this._dragging || this._dragY <= 0) return {};
      return { transform: `translateY(${this._dragY}px)`, transition: 'none' };
    },
  },
  methods: {
    closeSheet() {
      this.sheetOpen = false;
      this._dragY = 0;
      this._dragging = false;
    },

    navTo(path) {
      this.closeSheet();
      this.$nextTick(() => {
        if (this.$route.fullPath !== path) this.$router.push(path);
      });
    },

    async doLogout() {
      this.closeSheet();
      await this.$nextTick();
      await localStorage.removeItem("user");
      await localStorage.removeItem("token");
      await Swal.fire({
        position: "center",
        icon: "success",
        title: "تم تسجيل الخروج بنجاح",
        showConfirmButton: false,
        timer: 1000,
      });
      await this.$router.go("/");
    },

    async logout() {
      if (!this.auth) { this.$router.push("/login"); return; }
      await this.doLogout();
    },


    onTouchStart(e) {
      this._touchStartY = e.touches[0].clientY;
      this._dragY = 0;
      this._dragging = true;
    },
    onTouchMove(e) {
      if (!this._dragging) return;
      const delta = e.touches[0].clientY - this._touchStartY;
      this._dragY = Math.max(0, delta);
    },
    onTouchEnd() {
      this._dragging = false;
      if (this._dragY > 90) {
        this.closeSheet();
      } else {
        this._dragY = 0;
      }
    },
  },
  watch: {
    $route() { this.closeSheet(); },
    sheetOpen(open) {
      if (open) {
        document.body.style.overflow = 'hidden';
        window.addEventListener('keydown', this._onKeyDown);
        window.addEventListener('popstate', this._onPopState);
      } else {
        document.body.style.overflow = '';
        window.removeEventListener('keydown', this._onKeyDown);
        window.removeEventListener('popstate', this._onPopState);
      }
    },
  },
  created() {
    this.auth = this.$store.getters["isAuthenticated"];
    this._onKeyDown = (e) => { if (e.key === 'Escape') this.closeSheet(); };
    this._onPopState = () => { if (this.sheetOpen) this.closeSheet(); };
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this._onKeyDown);
    window.removeEventListener('popstate', this._onPopState);
    document.body.style.overflow = '';
  },
};
</script>

<style scoped>
/* ══════════════════════════════════════════
   MOBILE APP HEADER (.mnh)
   Shown on ≤768px, hidden on desktop
══════════════════════════════════════════ */
.mnh {
  display: none; /* desktop: off */
}

@media (max-width: 768px) {
  /* ── Show mobile header, hide desktop elements ── */
  .mnh {
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: space-between;
    padding: 0 0.25rem 0 0.5rem;
    gap: 0.5rem;
  }

  /* Hide the desktop hamburger toggle */
  .nav-toggler { display: none !important; }

  /* Hide the desktop navbar-nav entirely */
  .navbar-nav { display: none !important; }

  /* ── Brand title ── */
  .mnh-title {
    font-family: 'Cairo', 'Almarai', sans-serif;
    font-size: 0.92rem;
    font-weight: 700;
    color: #D4A017;
    white-space: nowrap;
    flex: 1;
    text-align: center;
  }

  /* ── End slot ── */
  .mnh-end {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    flex-shrink: 0;
  }

  /* ── Guest login button ── */
  .mnh-login-btn {
    display: inline-flex;
    align-items: center;
    gap: 0.35rem;
    padding: 0.38rem 0.85rem;
    background: linear-gradient(135deg, #D4A017, #B8860B);
    color: #0F0F0F !important;
    border-radius: 99px;
    font-size: 0.82rem;
    font-weight: 700;
    text-decoration: none;
    transition: opacity 0.15s ease, transform 0.15s ease;
    -webkit-tap-highlight-color: transparent;
    font-family: 'Cairo', 'Almarai', sans-serif;
  }
  .mnh-login-btn:active { transform: scale(0.95); opacity: 0.9; }
  .mnh-login-btn i { font-size: 0.8rem; }

  /* ── Auth avatar button ── */
  .mnh-avatar-btn {
    width: 38px;
    height: 38px;
    min-height: 38px;
    border-radius: 50%;
    background: linear-gradient(135deg, #D4A017, #B8860B);
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 14px rgba(212, 160, 23, 0.4);
    transition: transform 0.15s ease, box-shadow 0.15s ease;
    -webkit-tap-highlight-color: transparent;
    padding: 0;
  }
  .mnh-avatar-btn:active { transform: scale(0.92); box-shadow: 0 2px 8px rgba(212,160,23,.2); }

  .mnh-avatar-letter {
    font-size: 1rem;
    font-weight: 800;
    color: #0F0F0F;
    font-family: 'Cairo', 'Almarai', sans-serif;
    line-height: 1;
  }

}

/* ══════════════════════════════════════════
   DESKTOP CREDIT BLOCKS (unchanged)
══════════════════════════════════════════ */
.nav-credit {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  flex: 1;
  justify-content: center;
}

.nav-credit-text {
  font-size: 0.78rem;
  color: rgba(240,237,228,0.55);
  font-family: 'Cairo', sans-serif;
  white-space: nowrap;
  letter-spacing: 0.01em;
}
.nav-credit-text strong { color: #D4A017; font-weight: 800; }

.nav-credit-socials {
  display: flex;
  align-items: center;
  gap: 0.35rem;
}
.ncs-link {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 8px;
  color: #9CA3AF;
  background: transparent;
  transition: color 0.2s, background 0.2s, transform 0.2s;
  text-decoration: none;
}
.ncs-link svg { width: 15px; height: 15px; }
.ncs-link:hover { color: #D4A017; background: rgba(212,160,23,0.08); transform: translateY(-2px); }

.nav-credit-mobile { display: none; }
.nav-credit-mobile-inner {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.5rem 0.75rem;
  font-size: 0.78rem;
  color: rgba(240,237,228,0.5);
  font-family: 'Cairo', sans-serif;
  border-top: 1px solid rgba(212,160,23,0.1);
  margin-top: 0.25rem;
  padding-top: 0.75rem;
}
.nav-credit-mobile-inner strong { color: #D4A017; font-weight: 800; }

@media (max-width: 991px) {
  .nav-credit { display: none; }
  .nav-credit-mobile { display: block; }
}

/* ══════════════════════════════════════════
   MOBILE PROFILE BOTTOM SHEET  (.mbs-*)
   These are NOT scoped because Teleport renders
   outside this component's DOM subtree.
   We rely on unique class names for isolation.
══════════════════════════════════════════ */
</style>

<style>
/* ── Backdrop ── */
.mbs-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1200;
  background: rgba(0, 0, 0, 0.52);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
}

/* ── Sheet ── */
.mbs-sheet {
  position: fixed;
  max-height: 98dvh;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1201;
  background: #1A1A1A;
  border-radius: 28px 28px 0 0;
  box-shadow: 0 -8px 60px rgba(0, 0, 0, 0.7), 0 -1px 0 rgba(212,160,23,0.15);
  font-family: 'Cairo', 'Almarai', sans-serif;
  direction: rtl;
  overflow: hidden;
  will-change: transform;
  border-top: 1px solid rgba(212,160,23,0.2);
}

/* ── Top bar: handle + close ── */
.mbs-top-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 14px 16px 8px;
  position: relative;
}

.mbs-handle-bar {
  width: 40px;
  height: 5px;
  background: rgba(212,160,23,0.3);
  border-radius: 99px;
}

.mbs-close-btn {
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  width: 34px;
  height: 34px;
  min-height: 34px !important;
  border-radius: 50%;
  background: rgba(212,160,23,0.1);
  border: 1px solid rgba(212,160,23,0.2);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(240,237,228,0.6);
  -webkit-tap-highlight-color: transparent;
  transition: background 0.15s ease, transform 0.15s ease;
  margin-top: 15px;
}
.mbs-close-btn:active { background: rgba(212,160,23,0.2); transform: translateY(-50%) scale(0.9); }
.mbs-close-btn svg { width: 16px; height: 16px; }

/* ── Profile section ── */
.mbs-profile {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem 1.35rem 1.1rem;
  border-bottom: 1px solid rgba(212,160,23,0.12);
}

.mbs-avatar {
  width: 58px;
  height: 58px;
  border-radius: 50%;
  background: linear-gradient(135deg, #D4A017 0%, #B8860B 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-shadow: 0 8px 24px rgba(212, 160, 23, 0.35);
}

.mbs-avatar-letter {
  font-size: 1.55rem;
  font-weight: 900;
  color: #0F0F0F;
  line-height: 1;
}

.mbs-profile-name {
  font-size: 1.08rem;
  font-weight: 800;
  color: #F0EDE4;
  line-height: 1.2;
  margin-bottom: 0.35rem;
}

.mbs-profile-grade {
  display: inline-block;
  font-size: 0.75rem;
  font-weight: 700;
  color: #D4A017;
  background: rgba(212, 160, 23, 0.1);
  border: 1px solid rgba(212, 160, 23, 0.25);
  border-radius: 99px;
  padding: 0.18rem 0.7rem;
}

/* ── Nav list ── */
.mbs-nav {
  padding: 0.55rem 0;
}

.mbs-section-label {
  font-size: 0.68rem;
  font-weight: 700;
  color: rgba(212,160,23,0.7);
  text-transform: uppercase;
  letter-spacing: 0.07em;
  padding: 0.4rem 1.35rem 0.2rem;
}

.mbs-item {
  display: flex;
  align-items: center;
  gap: 0.9rem;
  width: 100%;
  padding: 0.82rem 1.35rem;
  background: transparent;
  border: none;
  cursor: pointer;
  text-align: right;
  -webkit-tap-highlight-color: transparent;
  transition: background 0.15s ease;
  position: relative;
}

.mbs-item:active {
  background: rgba(212,160,23,0.06);
}

.mbs-item-icon {
  width: 40px;
  height: 40px;
  border-radius: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.05rem;
  flex-shrink: 0;
  transition: transform 0.15s ease;
}
.mbs-item:active .mbs-item-icon {
  transform: scale(0.9);
}

.mbs-ic-blue   { background: rgba(59, 130, 246, 0.1);  color: #3B82F6; }
.mbs-ic-purple { background: rgba(212,175,55, 0.1);   color: #D4AF37; }
.mbs-ic-teal   { background: rgba(20, 184, 166, 0.1);  color: #14B8A6; }
.mbs-ic-orange { background: rgba(249, 115, 22, 0.1);  color: #F97316; }
.mbs-ic-green  { background: rgba(34, 197, 94, 0.1);   color: #22C55E; }
.mbs-ic-slate  { background: rgba(100, 116, 139, 0.1); color: #64748B; }
.mbs-ic-red    { background: rgba(239, 68, 68, 0.1);   color: #EF4444; }

.mbs-item-label {
  flex: 1;
  font-size: 0.97rem;
  font-weight: 600;
  color: rgba(240,237,228,0.85);
}

.mbs-item-logout .mbs-item-label {
  color: #EF4444;
}

.mbs-item-arrow {
  color: rgba(212,160,23,0.4);
  font-size: 0.85rem;
}

.mbs-divider {
  height: 1px;
  background: rgba(212,160,23,0.12);
  margin: 0.35rem 1.35rem;
}

.mbs-safe-area {
  height: max(16px, env(safe-area-inset-bottom));
}

/* ── Transitions ── */
.mbs-backdrop-enter-active { transition: opacity 0.28s ease; }
.mbs-backdrop-leave-active { transition: opacity 0.22s ease; }
.mbs-backdrop-enter-from,
.mbs-backdrop-leave-to   { opacity: 0; }

.mbs-sheet-enter-active {
  transition: transform 0.38s cubic-bezier(0.32, 0.72, 0, 1);
}
.mbs-sheet-leave-active {
  transition: transform 0.26s cubic-bezier(0.4, 0, 1, 1);
}
.mbs-sheet-enter-from,
.mbs-sheet-leave-to { transform: translateY(100%); }
</style>
